
import "../style/gradient.css"

export function gradient(colours) {

    const ret = {
        background: 'linear-gradient(-45deg, ' + colours.join(', ') + ')',
        animation: 'gradient 4s ease infinite',
        backgroundSize: '400% 400%',
    }

    return ret;
}